import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GetExpenseCategory_Result } from '@typeDefs/expenses/responses/expenses';
import { ApiResponse } from '@shared/model/api-response.model';

@Injectable({
  providedIn: 'root',
})
export class EmployeeApiService {
  private readonly http = inject(HttpClient);

  getCategory(): Observable<GetExpenseCategory_Result[]> {
    const url = '/Employee/CatgGet';
    return this.http.get<GetExpenseCategory_Result[]>(url);
  }

  catgAddEdit(expenseCatgID: number, expenseCatgName: string, isActive: boolean): Observable<ApiResponse> {
    return this.http.post<ApiResponse>('/Employee/CatgAddEdit', {
      expenseCatgID: expenseCatgID,
      expenseCatgName: expenseCatgName,
      isActive: isActive,
    });
  }

  catgDelete(expenseCatgID: number): Observable<ApiResponse> {
    return this.http.post<ApiResponse>('/Employee/CatgDelete', {
      expenseCatgID: expenseCatgID,
    });
  }
}
